module.exports = __webpack_public_path__ + "static/media/weatherly.2f7b747c.png";